import axios from 'axios';
import { USER_REQUEST } from '@/store/actions/user';

// Teams / Equipos (REN-1180). A team is a provider-scoped visibility filter managed from the
// operator form. Endpoints: /insurance/team/{list,save,delete}. Non-namespaced to match the
// permissions-set module conventions used by the same UI.
const state = {
  teamsList: [],
};

const getters = {
  teamsList: (state) => state.teamsList,
};

export function getTeamsList() {
  return axios.post('/insurance/team/list', {});
}

const actions = {
  fetchTeamsList({ commit }) {
    return getTeamsList()
      .then((response) => {
        commit('setTeamsList', response.data.items || []);
        return response.data.items || [];
      })
      .catch((error) => {
        console.error('Error fetching teams:', error);
        return [];
      });
  },
  // body: { teamId?, name?, leadUserIds?, memberUserIds? }
  // leadUserIds and memberUserIds are FULL replacements; an empty array clears the set.
  // A team may have several leads, and a user may be a member of several teams.
  saveTeam({ dispatch }, body) {
    return axios.post('/insurance/team/save', { ...body }).then((response) => {
      dispatch('fetchTeamsList');
      // Lead/membership changes affect the current user's visibility scope,
      // which is served by /insurance/user/detail — refresh it without a reload.
      dispatch(USER_REQUEST);
      return response.data;
    });
  },
  deleteTeam({ dispatch }, teamId) {
    return axios.post('/insurance/team/delete', { teamId }).then((response) => {
      dispatch('fetchTeamsList');
      dispatch(USER_REQUEST);
      return response.data;
    });
  },
};

const mutations = {
  setTeamsList(state, teamsList) {
    state.teamsList = teamsList;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
